module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/january-584504ec823f884f52fc1eca0442c260.png";